export default "__VITE_ASSET__f9c39e39__"